import React from 'react';
import SupportHoursTimeline from './SupportHoursTimeline';

const TicketsPopup = ({ isOpen, onClose, tickets, isLoading, orders, isLoadingOrders, t, isAdmin }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50 flex items-center justify-center p-4">
            <div className="relative p-6 pt-10 border w-full max-w-5xl shadow-2xl rounded-xl bg-white max-h-[90vh] flex flex-col">
                <button
                    onClick={onClose}
                    className="absolute top-3 right-3 text-gray-400 hover:text-gray-700 focus:outline-none transition-colors w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100"
                >
                    <span className="text-2xl leading-none">&times;</span>
                </button>

                <SupportHoursTimeline 
                    tickets={tickets} 
                    isLoading={isLoading} 
                    orders={orders} 
                    isLoadingOrders={isLoadingOrders} 
                    t={t} 
                    isAdmin={isAdmin} 
                />

                <div className="mt-6 pt-4 border-t flex justify-end">
                    <button
                        onClick={onClose}
                        className="px-8 py-2.5 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 font-bold transition-colors"
                    >
                        {t.close || 'Sluiten'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TicketsPopup;
